module.exports = "/images/hub-preview-mobile.png?6a3bb91637fc15e2bdf32f55884c0b82";